(() => {
  class HeaderMenuController {
    constructor(header) {
      this.header = header;
      this.toggleButton = document.querySelector('[data-mobile-menu-toggle]');
      this.drawer = document.querySelector('[data-mobile-menu-drawer]');
      this.overlay = document.querySelector('[data-mobile-menu-overlay]');

      this.dialog = new window.DialogController({
        bodyClass: 'mobile-menu-open',
        opener: this.toggleButton,
        panel: this.drawer
      });

      this.handleToggle = this.handleToggle.bind(this);
      this.handleOverlayClick = this.handleOverlayClick.bind(this);
    }

    connect() {
      this.toggleButton?.addEventListener('click', this.handleToggle);
      this.overlay?.addEventListener('click', this.handleOverlayClick);
    }

    disconnect() {
      this.toggleButton?.removeEventListener('click', this.handleToggle);
      this.overlay?.removeEventListener('click', this.handleOverlayClick);
    }

    handleToggle() {
      this.header.searchController?.close();
      this.dialog.toggle();
    }

    handleOverlayClick() {
      this.close();
    }

    close(options = {}) {
      this.dialog.close(options);
    }

    isOpen() {
      return this.dialog.isOpen();
    }
  }

  window.HeaderMenuController = HeaderMenuController;
})();
